export enum PREVIEW {
    /**
     * @value Edit link preview
     * @description Title for describing the link preview edition action.
     */
    EDIT_LINK_PREVIEW = 'GLOBAL.EDIT_LINK_PREVIEW',
    /**
     * @value Embed map
     * @description Text displayed as the title of the map dialog url preview
     */
    EMBED_MAP = 'WREX_EMBEDDED_MAP.EMBED_MAP',
    /**
     * @value This service is temporarily unavailable.
     * Please try again or paste the link directly in the content.
     * @description The error message when the preview server call fails in the insertion link dialog
     */
    INSERT_LINK_DIALOG_PREVIEW_BLOCK_ERROR_DEFAULT_ERROR = 'FRONT.INSERT_LINK_DIALOG.PREVIEW_BLOCK.ERROR.DEFAULT_ERROR',
    /**
     * @value The requested URL is unreachable.
     * Please make sure this URL exists.
     * @description The error message when the url doesn't exists in the insertion link dialog
     */
    INSERT_LINK_DIALOG_PREVIEW_BLOCK_ERROR_NOT_FOUND_URL = 'FRONT.INSERT_LINK_DIALOG.PREVIEW_BLOCK.ERROR.NOT_FOUND_URL',
    /**
     * @value Insert a link preview
     * @description The title of the link insertion dialog, used to insert links as attachments in posts and comments.
     */
    INSERT_LINK_DIALOG_TITLE = 'FRONT.INSERT_LINK_DIALOG.TITLE',
    /**
     * @value Link preview requires a valid URL, please change URL to insert link preview
     * @description The error message when the format of the url is invalid in the insertion link dialog
     */
    INSERT_LINK_DIALOG_URL_FIELD_ERROR_BAD_FORMAT = 'FRONT.INSERT_LINK_DIALOG.URL_FIELD.ERROR.BAD_FORMAT',
    /**
     * @value URL link
     * @description The label of the url field of the insertion link dialog
     */
    INSERT_LINK_DIALOG_URL_FIELD_LABEL = 'FRONT.INSERT_LINK_DIALOG.URL_FIELD.LABEL',
    /**
     * @value Google Map embed requires the browser top bar or short URL.
     * @description Error message displayed on the embed map writing experience when a user try a short google map link
     */
    INSERT_MAP_DIALOG_GMAP_URL_BAD_FORMAT = 'WREX_EMBEDDED_MAP.INSERT_MAP_DIALOG_GMAP_URL_BAD_FORMAT',
    /**
     * @value Embed map works only with Google maps and Open street map.
     * @description Text display to warn the user that only Google maps and Open street map links are valid in the map url preview dialog
     */
    INSERT_MAP_DIALOG_INFO_MESSAGE = 'WREX_EMBEDDED_MAP.INSERT_MAP_DIALOG_INFO_MESSAGE',
    /**
     * @value Map embed requires a valid URL, please change URL to embed map
     * @description Error text displayed when an user want to embed a map with an url that isn't google map or open street map on the url map preview dialog
     */
    INSERT_MAP_DIALOG_URL_FIELD_ERROR_BAD_FORMAT = 'WREX_EMBEDDED_MAP.INSERT_MAP_DIALOG.URL_FIELD.ERROR_BAD_FORMAT',
    /**
     * @value Insert a video
     * @description The title of the insert video dialog
     */
    INSERT_VIDEO_DIALOG_TITLE = 'FRONT.INSERT_VIDEO_DIALOG.TITLE',
    /**
     * @value Video requires a supported URL, please change URL to insert a video
     * @description The error message displayed when the user types an url that doesn't match a supported video website.
     */
    INSERT_VIDEO_DIALOG_URL_FIELD_ERROR_BAD_FORMAT = 'FRONT.INSERT_VIDEO_DIALOG.URL_FIELD.ERROR.BAD_FORMAT',
    /**
     * @value YouTube, Vimeo and Dailymotion URL are supported
     * @description In the insert video dialog, the helper message displayed below the url input, to inform the user which websites are supported.
     */
    INSERT_VIDEO_DIALOG_URL_FIELD_HELPER = 'FRONT.INSERT_VIDEO_DIALOG.URL_FIELD.HELPER',
    /**
     * @value Url link to video
     * @description In the insert video dialog, the label of the url input
     */
    INSERT_VIDEO_DIALOG_URL_FIELD_LABEL = 'FRONT.INSERT_VIDEO_DIALOG.URL_FIELD.LABEL',
    /**
     * @value Change thumbnail
     * @description Text displayed on the switch thumbnail button on a link preview, allowing user to use another of the thumbnail present in the website
     */
    LINK_PREVIEW_SWITCH_THUMBNAIL = 'LUMX.LINK_PREVIEW_SWITCH_THUMBNAIL',
}
